import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GameDetail, Link, processPromoBarData } from '../../index';
import './styles.less';

class PromoBar extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            isScrapePage: props.pageId === 'scrape',
            promoBarData: null
        };
    }

    componentDidMount() {
        const { isScrapePage } = this.state;
        const { cmsDapi } = this.props;
        if (isScrapePage) {
            fetch(`${cmsDapi}/en-us/sel-yes-promo-bar`)
                .then((res) => res.json())
                .then(
                    (result) => {
                        const promoBarData = processPromoBarData(result);
                        this.setState({
                            promoBarData
                        });
                    },
                    (error) => {
                        this.setState({
                            promoBarData: null
                        });
                    }
                );
        }
    }

    renderPromoBar(data) {
        const { primaryLabel, gameInfo, promoLink, sectionId } = data || {};
        const target = sectionId === 'thirdparty' ? '_top' : undefined;

        return (
            <div className="promo__bar">
                <div className="promo__bar--container">
                    <div className="promo__bar--gutter"></div>
                    <div className="promo__bar--primary-label">
                        <Link href={promoLink} target={target}>
                            <span className="promo__bar--primary-label-note">{primaryLabel && primaryLabel[0]}</span>
                            <span className="promo__bar--primary-label-detail">{primaryLabel && primaryLabel[1]}</span>
                        </Link>
                    </div>
                    {gameInfo && <GameDetail gameInfo={gameInfo} />}
                </div>
            </div>
        );
    }

    render() {
        const { isScrapePage, promoBarData } = this.state;

        // if we're on scrape route then we need to populate data with client fetched data
        const data = isScrapePage && promoBarData ? promoBarData : this.props;

        return this.renderPromoBar(data);
    }
}

PromoBar.propTypes = {
    baseURL: PropTypes.string,
    cmsDapi: PropTypes.string,
    gameInfo: PropTypes.object,
    pageId: PropTypes.string,
    primaryLabel: PropTypes.array,
    promoLink: PropTypes.string,
    sectionId: PropTypes.string
};

PromoBar.defaultProps = {};

export default PromoBar;
